<script>
import { get } from "lodash";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ForwardButton from "@/components/ForwardButton";
import BackwardButton from "@/components/BackwardButton";

const MESSAGE_BY_STATUS = {
  400: "Não foi possível enviar o formulário.",
  404: "Não encontramos a indicação que você está procurando.",
  406: "Sua indicação já foi confirmada.",
  409: "Você já sugeriu essa indicação.",
}

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    ForwardButton,
    BackwardButton,
  },
  data: () => ({
    radio: "0",
    showInputs: false,
    name: "",
    email: "",
    alreadyReferral: false,
  }),
  computed: {
    isAnonimous() {
      const label = get(this.$router, "history.current.params.company_label", null);
      return label === "anonima";
    },
  },
  watch: {
    radio(value) {
      if (value === "1") {
        this.showInputs = true;
      } else {
        this.showInputs = false;
      }
    },
  },
  methods: {
    async handleBackward() {
      await this.$store.dispatch("step/decrementCurrentStep");

      const { path } = this.$store.getters["step/current"];
      const { params } = this.$router.history.current;

      this.$router.push({
        name: path,
        params,
      });
    },
    async handleForward() {
      
      try {
        const isValid = await this.$refs.observer.validate();

        if (!isValid && this.radio === "1") {
          return;
        }

        const { params } = this.$router.history.current;

        if (this.radio === "0" || this.alreadyReferral) {
          await this.$store.dispatch("step/completeStep");
          await this.$store.dispatch("step/incrementCurrentStep");

          const { path } = this.$store.getters["step/current"];

          this.$router.push({
            name: path,
            params,
          });
        } else {
          this.$vs.loading({ text: "Enviando..." });
  
          const vacancy_id = get(this.$router, "history.current.params.vacancy_id", null);
  
          this.$http.post("/api/v1/indications?debug=true", {
            vacancy_id: vacancy_id,
            name: this.name,
            email: this.email,
          })
          .then(async () => {
            sessionStorage.setItem("@recrutei:talent:referral_name", this.name);
            sessionStorage.setItem("@recrutei:talent:referral_email", this.email);

            this.$vs.loading.close();

            await this.$store.dispatch("step/completeStep");
            await this.$store.dispatch("step/incrementCurrentStep");

            const { path } = this.$store.getters["step/current"];

            this.$vs.notify({
              text: "A indicação foi solicitada com sucesso!",
              title: "Sucesso!",
              icon: "icon-alert-circle",
              color: "success",
              iconPack: "feather",
              position: "top-right",
              time: 5000,
            });

            this.$router.push({
              name: path,
              params,
            });
          })
          .catch((error) => {
            const status = get(error, "response.status", 0);
            const message = MESSAGE_BY_STATUS[status];

            this.$vs.notify({
              text: message,
              title: "Opps!",
              icon: "icon-alert-circle",
              color: "warning",
              iconPack: "feather",
              position: "top-right",
              time: 5000,
            });

            this.$vs.loading.close();
          });
        }
      } catch (error) {
        this.$vs.loading.close();

        const message = get(
          error,
          "response.data.message",
          "Não foi possível enviar o formulário"
        );

        this.$vs.notify({
          text: message,
          title: "Opps!",
          icon: "icon-alert-circle",
          color: "warning",
          iconPack: "feather",
          position: "top-right",
          time: 5000,
        });
      }
    },
  },
  created() {
    console.log(typeof get(this.$router, "history.current.params.vacancy_id", null));

    const name = sessionStorage.getItem("@recrutei:talent:referral_name");
    const email = sessionStorage.getItem("@recrutei:talent:referral_email");

    if (name && email) {
      this.name = name;
      this.email = email;
      this.radio = "1";
      this.alreadyReferral = true;
    }
  },
};
</script>

<template>
  <div class="card bg-white rounded">
    <vs-row class="my-4">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="12">
        <feather-icon
          class="mr-4"
          icon="GiftIcon"
          svgClasses="text-black stroke-current w-36.96 h-36.96"
        />
        <h1 class="md:lg m-0">Programa de Indicação</h1>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="12">
        <span class="my-2 md:text-base">
          Informe aqui o nome e o e-mail de quem te indicou para o programa de indicação.
        </span>
      </vs-col>
    </vs-row>
    <div class="container">
      <p>Você foi indicado para esta vaga?</p>
      <div class="container__radio-group">
        <vs-radio v-model="radio" vs-value="1" :disabled="isAnonimous">Sim</vs-radio>
        <vs-radio v-model="radio" vs-value="0" :disabled="isAnonimous">Não</vs-radio>
      </div>
      <p class="anonimous__msg" v-if="isAnonimous">Não é possível fazer uma indicação em uma vaga anônima!</p>
      <validation-observer
        tag="form"
        ref="observer"
        v-show="showInputs"
        v-slot="{ invalid }"
        @submit.prevent="handleForward()"
      >
        <div class="container__form-group">
          <validation-provider
            class="w-full"
            name="nome"
            rules="required"
            v-slot="{ errors }"
          >
            <vs-input
              class="w-full"
              v-model="name"
              label="Nome Completo"
              type="text"
              placeholder="Nome Completo"
              description-text="Nome Completo de quem te indicou"
              :disabled="alreadyReferral"
              :danger="errors.length > 0"
              :danger-text="errors[0]"
            />
          </validation-provider>
          <validation-provider
            class="w-full"
            name="email"
            rules="required|email"
            v-slot="{ errors }"
          >
            <vs-input
              class="w-full"
              v-model="email"
              label="E-mail"
              type="email"
              placeholder="E-mail"
              description-text="Um email de confirmação será enviado e não será possível editar essa informação."
              :disabled="alreadyReferral"
              :danger="errors.length > 0"
              :danger-text="errors[0]"
            />
          </validation-provider>
        </div>
        <div class="button-group">
          <backward-button @click="handleBackward()" />
          <forward-button :disabled="invalid" />
        </div>
      </validation-observer>
    </div>
    <div v-show="!showInputs" class="button-group">
      <backward-button @click="handleBackward()" />
      <forward-button @click="handleForward()" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.container {
  margin: 2.0625rem 0;

  .anonimous__msg {
    margin-top: 1rem;
    font-size: 0.875rem;
    color: #ff0000;
    &::before {
      content: "* ";
    }
  }

  &__radio-group {
    label:first-child {
      margin-top: 1rem;
      margin-right: 2rem;
    }
  }

  &__form-group {
    width: 100%;
    display: flex;
    align-items: center;
    margin-top: 1rem;

    span:first-child {
      margin-right: 1rem;
    }

    @media (max-width: 768px) {
      flex-wrap: wrap;

      span:first-child {
        margin-bottom: 1rem;
        margin-right: 0;
      }
    }
  }
}

.button-group {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-top: 2rem;
}
</style>
